import './RowLayout.scss';
import classNames from 'classnames';
import { PropsWithChildren, ReactElement } from 'react';
interface IProps extends PropsWithChildren {
  size: 'none' | 'xs' | 'sm' | 'md' | 'l';
  spread?: boolean;
  className?: string;
}

export const RowLayout = ({ children, className, size, spread }: IProps): ReactElement => (
  <div className={classNames('row-layout', className, size, { spread })}>{children}</div>
);
